import Webscoket from './webscoket.vue';

export default Webscoket;
